import { css } from '@linaria/core';
import { useResourcePricing } from 'hooks/useResourcePricing';
import { isTokenBasedModel, isValidModelPrice, PricingChipContent, PricingChipWithPopover } from './Pricing.shared';
import { TablePricingView } from './TablePricingView';
type ModelPricingProps = {
  model: CF.API.Models.Model;
  border?: boolean;
  tableView?: boolean;
};
export const ModelPricing: React.FC<ModelPricingProps> = ({
  model,
  border = true,
  tableView
}) => {
  const modelPrice = useResourcePricing({
    models: [model]
  })?.[0];
  if (!isValidModelPrice(modelPrice)) {
    return null;
  }
  if (tableView) {
    return <TablePricingView dataTestid="model-pricing-table">
        <tbody>
          <tr>
            <td className="model-id">Model Pricing</td>
            <td className="grey-bold-price price">SERVERLESS</td>
          </tr>
          <tr>
            <td className="model-id">Cost</td>
            <td className="price">
              <PricingChipContent modelPrice={modelPrice} />
            </td>
          </tr>
        </tbody>
      </TablePricingView>;
  }
  return <div className={playgroundPricingContainer}>
      <PricingChipWithPopover border={border} isTokenPricing={isTokenBasedModel(modelPrice)}>
        <PricingChipContent modelPrice={modelPrice} />
      </PricingChipWithPopover>
    </div>;
};
const playgroundPricingContainer = "omponents__Pricing__ModelPricing_tsx-playgroundPricingContainer-p1e5bo6u";

require("./ModelPricing.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./ModelPricing.tsx");